import { MenuItem } from '@material-ui/core';
import { Button, FormControl, Grid, InputLabel, NativeSelect, Paper, Select, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import ATSnackbar from '../../layout/ATSnackbar';
import { getStrategies } from '../../portfolio/PortfolioConfig';

const shrinkProp = { shrink: true };

export const AddDeleteStrategyForAll = ({ user, reloadPortfolioStrategies }) => {
    const defaultStrategyRow = {
        tradeStrategy: "UPTREND",
        broker: "ANGEL_ONE",
        maxPercentPerTrade: 0.0,
        stopLossInPercentage: 0.0,
        investedAmount: 0.0,
    };

    const { register, control, setValue, getValues, formState: { errors }, handleSubmit } = useForm({
        defaultValues: defaultStrategyRow
    })

    const [strategies, setStrategies] = useState([]);
    const [notification, setNotification] = useState({
        open: false,
        message: ''
    })

    useEffect(() => {
        getStrategies(user, setStrategies);
    }, [user])

    useEffect(() => {
        setValue('tradeStrategy', strategies?.[0]?.name)
    }, [user, strategies])

    const onSubmitAdd = data => {
        fetch('/algo-trading/api/admin/strategies/apply-for-all', {
            method: 'post',
            body: JSON.stringify(data),
            headers: {
                'Authorization': user?.credential,
                'Content-Type': 'application/json'
            }
        }).then(r => r.text()).then(() => {
            reloadPortfolioStrategies()
            showNotification('Strategy applied for all active users.')
        }).catch(e => showNotification('Error adding strategy for all active users'))
    }

    const onClickDelete = () => {
        const strategyName = getValues()?.tradeStrategy

        fetch(`/algo-trading/api/admin/strategies/${strategyName}/inactivate-for-all`, {
            method: 'delete',
            headers: {
                'Authorization': user?.credential,
                'Content-Type': 'application/json'
            }
        }).then(r => r.text()).then(() => {
            reloadPortfolioStrategies()
            showNotification('Strategy made inactive for all active users.')
        }).catch(e => showNotification('Error inactivating strategy for all active users'))
    }

    const showNotification = message => setNotification({ open: true, message })


    return (
        <Paper elevation={2} component={Grid} item xs={12} paddingY={5}>
            {notification.open && <ATSnackbar message={notification.message} open={notification.open} setOpen={setNotification} severity={'warning'} />}
            <form>
                <Grid item lg={12} paddingY={2}>
                    <Typography variant='h6'>Manage Strategies for all active users</Typography>
                </Grid>
                <Grid container justifyContent='space-around' spacing={2}>
                    <Grid item xs={8} sm={3} md={2} lg={1}>
                        <Controller
                            name="broker"
                            control={control}
                            render={({ field }) => <Select {...field}
                                error={errors?.['broker'] != undefined}
                                helperText={errors && errors?.['broker']?.message}
                                required
                            >
                                <MenuItem key='ANGEL_ONE' value='ANGEL_ONE'>Angel One</MenuItem>
                                <MenuItem key='KOTAK' value='KOTAK'>Kotak</MenuItem>
                                <MenuItem key='DHAN' value='DHAN'>Dhan</MenuItem>
                                <MenuItem key='PROSTOCKS' value='PROSTOCKS'>ProStocks</MenuItem>
                                <MenuItem key='ACA' value='ACA'>ACA</MenuItem>
                            </Select>
                            }
                        />
                    </Grid>
                    <Grid item xs={10} sm={4} md={2} lg={3}>
                        <FormControl fullWidth>
                            <InputLabel id='strategy-label'>Strategy</InputLabel>
                            <Controller
                                name={`tradeStrategy`}
                                control={control}
                                label="Strategy"
                                labelId='strategy-label'
                                defaultValue={`tradeStrategy`}
                                render={({ field }) => (
                                    <NativeSelect {...field} label="Strategy" autowidth
                                        id='strategy-label' inputProps={{
                                            id: 'strategy-label',
                                        }}>
                                        <option value="0" key="-1">--Select--</option>
                                        {strategies && strategies.length > 0 && strategies.map(st =>
                                            <option value={st.name} key={st.name}>{st.displayName}</option>
                                        )}
                                    </NativeSelect>
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} md={1} lg={1}>
                        <TextField label="Max % / Trade" variant="outlined" size="small" InputLabelProps={shrinkProp}
                            error={errors?.['maxPercentPerTrade'] != undefined}
                            helperText={errors && errors?.['maxPercentPerTrade']?.message}
                            required
                            fullWidth
                            {...register(`maxPercentPerTrade`, { required: true, })} />
                    </Grid>
                    <Grid item xs={4} md={1} lg={1}>
                        <TextField label="Stop Loss %" variant="outlined" size="small"
                            InputLabelProps={shrinkProp}
                            error={errors?.['stopLossInPercentage'] != undefined}
                            helperText={errors && errors?.['stopLossInPercentage']?.message}
                            required
                            fullWidth
                            {...register(`stopLossInPercentage`, { required: true, min: { value: 0.001, message: 'should be > 0' }, max: { value: 10, message: 'Max 10%' } })} />
                    </Grid>
                    <Grid item lg={2}>
                        <Button variant='contained' type='submit' onClick={handleSubmit(onSubmitAdd)}>Add for all</Button>
                    </Grid>
                    <Grid item lg={2}>
                        <Button variant='contained' color='error' onClick={onClickDelete}>Delete for all</Button>
                    </Grid>
                </Grid>
            </form>
        </Paper>
    )
}
